module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/5-on-928b8587145bdcded755978de13ab14d.png";